import { HandwriteSearchApp } from "./app/HandwriteSearchApp";

const app = new HandwriteSearchApp();

void app.mount(document.body);
